import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
    // base: '/help/',
    // mode:'history',
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            children:[
                {
                    path: "/*",
                    name: "home",
                    component: Home,
                }
            ]
        }
    ]
});
